import { RESET_DOCUMENTS_REQUESTED, RESET_DOCUMENTS_COMPLETED } from './types';

const resetAction = () => (dispatch) => {
  dispatch({
    type: RESET_DOCUMENTS_REQUESTED,
  });

  dispatch({
    type: RESET_DOCUMENTS_COMPLETED,
  });
};

export default resetAction;
